import React, { useContext, useState } from "react";
import AssetDetails from "./AssetDetails";
import TicketDetails from "./TicketDetails";
import Alerts from "./Alerts";
import VendorProjects from "./VendorProjects";
import VendorKPI from "./VendorKPI";
import Navbar from "../../../../common/layout/Navbar";
import {
  empType,
  JunctionStatus,
  LicenseTypes,
  PageFrom,
} from "../../../../../utils/Enum.types";
import Challans from "./Challans";
import { AppContext } from "../../../../../context/context";
import { AppProvider } from "../../maps/context/context";
import Table, { TicketTablePageFor } from "../../reports/ticketwise/Table";
import { TicketsQueryType } from "../../../../../queries/types";
import TableDetails from "./vendor/TableDetails";
import JunctionStatusCount from "./JunctionStatusCount";
import {
  convertEnumToLabels,
  CustomModal,
} from "../../../../../utils/UtilFunctions";
import {
  AddModalStyles,
  ViewModalStyles,
} from "../../../../../styles/CustomModalStyles";
import { Title } from "../../../../../stories/Title/Title";
import CompleteSignalDetails, {
  JunctionPageType,
} from "./view/CompleteSignalDetails";
import Close from "../../../../../images/Close.svg";
import MinutesOfMeeting from "../MinutesOfMeeting";
import WorkProgress from "../../work_progress/WorkProgress";

const Mainpage = () => {
  const { state } = useContext(AppContext);
  const [junctionDetails, setJunctionDetals] = useState(false);
  const [junctionStatus, setJunctionStatus] = useState<JunctionStatus | null>(
    null
  );

  const [ticketDetails, setTicketDetails] = useState(false);

  const isStationLevelPolice =
    state.empSubType === empType.PC ||
    state.empSubType === empType.WPC ||
    state.empSubType === empType.ASI ||
    state.empSubType === empType.WASI ||
    state.empSubType === empType.PSI ||
    state.empSubType === empType.WPSI ||
    state.empSubType === empType.HELP_DESK ||
    state.empSubType === empType.TECHNICIAN;

  return (
    <AppProvider>
      <Navbar NavType={LicenseTypes.DASHBOARD} />
      <div className="d-main-page">
        <div className="d-main-page__block">
          <div className="d-main-page__block--top">
            <AssetDetails />
            {(state.empSubType === empType.JCP ||
              state.empSubType === empType.PMU ||
              state.empSubType === empType.HELP_DESK ||
              state.empSubType === empType.ACP ||
              state.empSubType === empType.VENDOR_MANAGER ||
              isStationLevelPolice) && (
              <JunctionStatusCount
                setJunctionDetals={setJunctionDetals}
                setJunctionType={setJunctionStatus}
              />
            )}
            {/* <LocationDetails /> */}
            {!isStationLevelPolice ? <MinutesOfMeeting /> : null}
            <TicketDetails />
            {/* <Alerts /> */}
          </div>
          {state.empSubType === empType.JCP ||
          state.empSubType === empType.PMU ? (
            <div className="d-main-page__block--bottom">
              {/* <VendorProjects /> */}
              {/* <VendorKPI /> */}
              {/* <Challans /> */}
              <WorkProgress pageFrom={PageFrom.DASHBOARD} />
            </div>
          ) : state.empSubType === empType.HELP_DESK ? (
            <>
              <div className="d-main-page__block--bottom">
                <div className="d-main-page__block--bottom--table">
                  <Table
                    queryType={TicketsQueryType.ALL}
                    pageFor={TicketTablePageFor.DASHBOARD}
                    setModalFlag={setTicketDetails}
                  />
                  <button
                    className="d-main-page__block--bottom--view"
                    onClick={() => setTicketDetails(!ticketDetails)}
                  >
                    View all
                  </button>
                </div>
              </div>
            </>
          ) : state.empSubType === empType.VENDOR_MANAGER ? (
            <div className="d-main-page__block--bottom--vendor">
              <TableDetails />

              <button
                className="d-main-page__block--bottom--view"
                onClick={() => setTicketDetails(!ticketDetails)}
              >
                View all
              </button>
            </div>
          ) : null}
        </div>
      </div>

      <CustomModal
        style={AddModalStyles}
        isOpen={junctionDetails}
        onRequestClose={() => setJunctionDetals(!junctionDetails)}
        contentComponent={
          <>
            <div className="d-asset-details__complete-details">
              <div className="d-asset-details__complete-details--title">
                <Title>{convertEnumToLabels(junctionStatus)}</Title>
                <img
                  src={Close}
                  alt=""
                  onClick={() => setJunctionDetals(!junctionDetails)}
                />
              </div>
              <CompleteSignalDetails
                setModalFlag={setJunctionDetals}
                junctionPageType={JunctionPageType.JUNCTION_STATUS}
                selectedJunctionStatus={junctionStatus!}
              />
            </div>
          </>
        }
      />
      <CustomModal
        style={ViewModalStyles}
        isOpen={ticketDetails}
        onRequestClose={() => setTicketDetails(!ticketDetails)}
        contentComponent={
          <>
            <div className="d-asset-details__ticket-details">
              <div className="d-asset-details__ticket-details--title">
                <Title>Ticket Details</Title>
                <img
                  src={Close}
                  alt=""
                  onClick={() => setTicketDetails(!ticketDetails)}
                />
              </div>
              <Table
                queryType={TicketsQueryType.ALL}
                pageFor={TicketTablePageFor.MODAL}
                setModalFlag={setTicketDetails}
              />
            </div>
          </>
        }
      />
    </AppProvider>
  );
};

export default Mainpage;
